var map = {
	"./ion-action-sheet-controller_8.entry.js": [
		"0d7e",
		"chunk-0e072455"
	],
	"./ion-action-sheet-ios.entry.js": [
		"6039",
		"chunk-4f3678b7"
	],
	"./ion-action-sheet-md.entry.js": [
		"2a5b",
		"chunk-dffd094a"
	],
	"./ion-alert-ios.entry.js": [
		"86e0",
		"chunk-41729f35"
	],
	"./ion-alert-md.entry.js": [
		"aab5",
		"chunk-45df0daa"
	],
	"./ion-app_8-ios.entry.js": [
		"daa4",
		"chunk-58018476"
	],
	"./ion-app_8-md.entry.js": [
		"d81a",
		"chunk-dae3f45e"
	],
	"./ion-avatar_3-ios.entry.js": [
		"7636",
		"chunk-4da36b15"
	],
	"./ion-avatar_3-md.entry.js": [
		"9ace",
		"chunk-245db3ed"
	],
	"./ion-back-button-ios.entry.js": [
		"76f7",
		"chunk-4d93dcb2"
	],
	"./ion-back-button-md.entry.js": [
		"bf96",
		"chunk-268044d4"
	],
	"./ion-backdrop-ios.entry.js": [
		"9bb0",
		"chunk-2d0f060d"
	],
	"./ion-backdrop-md.entry.js": [
		"3394",
		"chunk-2d0b9671"
	],
	"./ion-button_2-ios.entry.js": [
		"60a1",
		"chunk-7a234d26"
	],
	"./ion-button_2-md.entry.js": [
		"062c",
		"chunk-57a83ac0"
	],
	"./ion-card_5-ios.entry.js": [
		"df70",
		"chunk-bd819d48"
	],
	"./ion-card_5-md.entry.js": [
		"41e5",
		"chunk-469a106c"
	],
	"./ion-checkbox-ios.entry.js": [
		"aada",
		"chunk-7d21e4da"
	],
	"./ion-checkbox-md.entry.js": [
		"2f4c",
		"chunk-6435f914"
	],
	"./ion-chip-ios.entry.js": [
		"7fbb",
		"chunk-6d941db0"
	],
	"./ion-chip-md.entry.js": [
		"af74",
		"chunk-29757256"
	],
	"./ion-col_3.entry.js": [
		"7c04",
		"chunk-2d0e1b06"
	],
	"./ion-datetime_3-ios.entry.js": [
		"eed0",
		"chunk-de1eb938"
	],
	"./ion-datetime_3-md.entry.js": [
		"cabb",
		"chunk-972e2b1c"
	],
	"./ion-fab_3-ios.entry.js": [
		"4e51",
		"chunk-0471966a"
	],
	"./ion-fab_3-md.entry.js": [
		"38d3",
		"chunk-3172533a"
	],
	"./ion-img.entry.js": [
		"acf3",
		"chunk-2d213925"
	],
	"./ion-infinite-scroll_2-ios.entry.js": [
		"2803",
		"chunk-a9591d90"
	],
	"./ion-infinite-scroll_2-md.entry.js": [
		"b7c2",
		"chunk-a92d751a"
	],
	"./ion-input-ios.entry.js": [
		"5096",
		"chunk-198e3942"
	],
	"./ion-input-md.entry.js": [
		"2d16",
		"chunk-ae124cc0"
	],
	"./ion-item-option_3-ios.entry.js": [
		"c563",
		"chunk-09cd0b70"
	],
	"./ion-item-option_3-md.entry.js": [
		"3286",
		"chunk-658c23da"
	],
	"./ion-item_8-ios.entry.js": [
		"1af7",
		"chunk-5b23fdd4"
	],
	"./ion-item_8-md.entry.js": [
		"7c02",
		"chunk-2a9b8bee"
	],
	"./ion-loading-ios.entry.js": [
		"4d5d",
		"chunk-0867d75f"
	],
	"./ion-loading-md.entry.js": [
		"b6df",
		"chunk-882768b0"
	],
	"./ion-menu_4-ios.entry.js": [
		"9936",
		"chunk-28a9e288"
	],
	"./ion-menu_4-md.entry.js": [
		"9d0e",
		"chunk-0ffeab9f"
	],
	"./ion-modal-ios.entry.js": [
		"9cc9",
		"chunk-57598eed"
	],
	"./ion-modal-md.entry.js": [
		"c8bc",
		"chunk-4a868a77"
	],
	"./ion-nav_5.entry.js": [
		"f487",
		"chunk-3ee4eca5"
	],
	"./ion-popover-ios.entry.js": [
		"f31f",
		"chunk-3609acea"
	],
	"./ion-popover-md.entry.js": [
		"3c61",
		"chunk-f8c074fc"
	],
	"./ion-progress-bar-ios.entry.js": [
		"53d4",
		"chunk-0a1eaca9"
	],
	"./ion-progress-bar-md.entry.js": [
		"77f1",
		"chunk-36da2acc"
	],
	"./ion-radio_2-ios.entry.js": [
		"5547",
		"chunk-6a5dbffb"
	],
	"./ion-radio_2-md.entry.js": [
		"dc25",
		"chunk-f71781cc"
	],
	"./ion-range-ios.entry.js": [
		"353f",
		"chunk-32cdbffc"
	],
	"./ion-range-md.entry.js": [
		"3323",
		"chunk-ea2d3954"
	],
	"./ion-refresher_2-ios.entry.js": [
		"dedf",
		"chunk-a92a499c"
	],
	"./ion-refresher_2-md.entry.js": [
		"6b32",
		"chunk-a9543e8c"
	],
	"./ion-reorder_2-ios.entry.js": [
		"677e",
		"chunk-6da41528"
	],
	"./ion-reorder_2-md.entry.js": [
		"6733",
		"chunk-6da41684"
	],
	"./ion-ripple-effect.entry.js": [
		"9d3f",
		"chunk-2d0f0814"
	],
	"./ion-route_4.entry.js": [
		"7c90",
		"chunk-793ec3d8"
	],
	"./ion-searchbar-ios.entry.js": [
		"9083",
		"chunk-1f16206c"
	],
	"./ion-searchbar-md.entry.js": [
		"5716",
		"chunk-37ff8997"
	],
	"./ion-segment_2-ios.entry.js": [
		"747c",
		"chunk-c377db64"
	],
	"./ion-segment_2-md.entry.js": [
		"8628",
		"chunk-9f295fda"
	],
	"./ion-select_3-ios.entry.js": [
		"045e",
		"chunk-4960e528"
	],
	"./ion-select_3-md.entry.js": [
		"4a00",
		"chunk-55fd9bc5"
	],
	"./ion-slide_2-ios.entry.js": [
		"2edb",
		"chunk-2d0be327"
	],
	"./ion-slide_2-md.entry.js": [
		"b4c5",
		"chunk-2d20fcba"
	],
	"./ion-spinner.entry.js": [
		"cdda",
		"chunk-45636d0e"
	],
	"./ion-split-pane-ios.entry.js": [
		"103b",
		"chunk-2d0aa1e4"
	],
	"./ion-split-pane-md.entry.js": [
		"41d4",
		"chunk-2d0c0883"
	],
	"./ion-tab-bar_2-ios.entry.js": [
		"db46",
		"chunk-6d44dfd7"
	],
	"./ion-tab-bar_2-md.entry.js": [
		"dd4b",
		"chunk-efc7162e"
	],
	"./ion-tab_2.entry.js": [
		"e0cb",
		"chunk-dada39de"
	],
	"./ion-text.entry.js": [
		"084e",
		"chunk-d6be8784"
	],
	"./ion-textarea-ios.entry.js": [
		"5d19",
		"chunk-6ae2b080"
	],
	"./ion-textarea-md.entry.js": [
		"e136",
		"chunk-2aed0630"
	],
	"./ion-toast-ios.entry.js": [
		"f878",
		"chunk-41c90a6b"
	],
	"./ion-toast-md.entry.js": [
		"d670",
		"chunk-3bd70db3"
	],
	"./ion-toggle-ios.entry.js": [
		"ecc3",
		"chunk-dd32cf7c"
	],
	"./ion-toggle-md.entry.js": [
		"072f",
		"chunk-3b7db6f5"
	],
	"./ion-virtual-scroll.entry.js": [
		"ec57",
		"chunk-2d2304b6"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "ed97";
module.exports = webpackAsyncContext;